module.exports = __webpack_public_path__ + "static/map-3b691190f05ab4c8200d6b909d8d74c6.jpg";